/* Basic Musthaves — cart drawer controller (Spoor 11, Fase 3) */
(function () {
  'use strict';

  var drawer = document.querySelector('[data-mts-cart]');
  var scrim = document.querySelector('[data-mts-cart-scrim]');
  if (!drawer || !scrim) return;

  var freeShip = parseInt(drawer.getAttribute('data-free-ship'), 10) || 0;
  var elBody = drawer.querySelector('[data-mts-cart-body]');
  var elCount = drawer.querySelector('[data-mts-cart-count]');
  var elSub = drawer.querySelector('[data-mts-cart-subtotal]');
  var elFill = drawer.querySelector('[data-mts-ship-fill]');
  var elShipText = drawer.querySelector('[data-mts-ship-text]');

  function money(c) { return '€' + (c / 100).toFixed(2).replace('.', ','); }

  function icon(name) {
    if (name === 'minus') return '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14"/></svg>';
    if (name === 'plus') return '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 5v14M5 12h14"/></svg>';
    return '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8"><path d="m6 6 12 12M18 6 6 18"/></svg>';
  }

  function render(cart) {
    // header badges
    document.querySelectorAll('[data-mts-cart-badge]').forEach(function (b) {
      b.textContent = cart.item_count;
      b.hidden = cart.item_count === 0;
    });
    if (elCount) elCount.textContent = cart.item_count + (cart.item_count === 1 ? ' artikel' : ' artikelen');
    if (elSub) elSub.textContent = money(cart.total_price);

    // free-ship bar
    if (freeShip > 0 && elFill) {
      var pct = Math.min(100, (cart.total_price / freeShip) * 100);
      elFill.style.width = pct + '%';
      var remaining = freeShip - cart.total_price;
      if (elShipText) elShipText.textContent = remaining > 0
        ? ('Nog ' + money(remaining) + ' tot gratis verzending')
        : 'Gefeliciteerd — je hebt gratis verzending!';
    }

    // items
    if (cart.items.length === 0) {
      elBody.innerHTML = '<div class="mts-cart-empty"><div class="ico"><svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M5 8h14l-1 12H6L5 8z"/><path d="M8 8V6a4 4 0 0 1 8 0v2"/></svg></div>Je winkelwagen is leeg.</div>';
      return;
    }
    elBody.innerHTML = cart.items.map(function (it) {
      var variant = (it.variant_title && it.variant_title !== 'Default Title') ? '<div class="mts-eyebrow" style="margin-top:2px">' + it.variant_title + '</div>' : '';
      var img = it.image ? '<img src="' + it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" loading="lazy">' : '';
      return '' +
        '<div class="mts-cart-line">' +
          '<div class="mts-cart-line-img">' + img + '</div>' +
          '<div class="mts-cart-line-info">' +
            '<div class="mts-card-brand">' + (it.product_type || it.vendor || '') + '</div>' +
            '<div style="font-size:13px;font-weight:500;line-height:1.3;margin-top:2px">' + it.product_title + '</div>' + variant +
            '<div style="display:flex;justify-content:space-between;align-items:center;margin-top:8px">' +
              '<div class="mts-cart-qty">' +
                '<button class="mts-icon-btn" type="button" data-mts-change="' + it.key + '" data-qty="' + (it.quantity - 1) + '" aria-label="Minder">' + icon('minus') + '</button>' +
                '<span>' + it.quantity + '</span>' +
                '<button class="mts-icon-btn" type="button" data-mts-change="' + it.key + '" data-qty="' + (it.quantity + 1) + '" aria-label="Meer">' + icon('plus') + '</button>' +
              '</div>' +
              '<div style="font-weight:600;font-size:14px;font-feature-settings:\'tnum\'">' + money(it.final_line_price) + '</div>' +
            '</div>' +
          '</div>' +
          '<button class="mts-icon-btn" type="button" data-mts-change="' + it.key + '" data-qty="0" style="align-self:flex-start" aria-label="Verwijderen">' + icon('close') + '</button>' +
        '</div>';
    }).join('');
  }

  function refresh() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(render); }

  function open() { scrim.hidden = false; drawer.hidden = false; document.body.style.overflow = 'hidden'; }
  function close() { scrim.hidden = true; drawer.hidden = true; document.body.style.overflow = ''; }

  function change(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(render);
  }

  function addToCart(form) {
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function () { return refresh(); })
      .then(function () { open(); })
      .catch(function (e) { console.log('[mts-cart] add failed', e); })
      .finally(function () { if (btn) btn.disabled = false; });
  }

  // delegated events
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.matches && form.matches('form[action*="/cart/add"]')) { e.preventDefault(); addToCart(form); }
  });
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-mts-cart-open]');
    if (opener) { e.preventDefault(); open(); refresh(); return; }
    var chg = e.target.closest('[data-mts-change]');
    if (chg) { change(chg.getAttribute('data-mts-change'), parseInt(chg.getAttribute('data-qty'), 10)); return; }
  });
  scrim.addEventListener('click', close);
  drawer.querySelector('[data-mts-cart-close]').addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) close(); });

  // initial
  refresh();
})();
